import { ActionMenuDesktop } from './ActionMenuDesktop';
import { ActionMenuMobile } from './ActionMenuMobile';
import type { ActionMenuIconValue } from './ActionMenuIcon';

export interface ActionMenuItem {
  label: string;
  icon?: ActionMenuIconValue;
  onClick?: () => void;
  disabled?: boolean;
  destructive?: boolean;
}

interface ActionMenuProps {
  items?: ActionMenuItem[];
  actions?: ActionMenuItem[];
  options?: ActionMenuItem[];
  align?: 'left' | 'right';
  className?: string;
  buttonClassName?: string;
  label?: string;
}

export function ActionMenu(props: ActionMenuProps) {
  const items = props.items ?? props.actions ?? props.options ?? [];

  return (
    <>
      <div className="hidden md:block">
        <ActionMenuDesktop {...props} items={items} />
      </div>
      <div className="flex md:hidden">
        <ActionMenuMobile items={items} className={props.className} />
      </div>
    </>
  );
}
